'use strict';
var parent = require('../../web/url-search-params');
require('../../modules/web.dom-collections.iterator');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/url-search-params/index.js
// module id = 786
// module chunks = 13